import axios from "axios";
export const collect = (id, model, type, platforms, additional_data = null) => {
    if (import.meta.env.SSR) {
        return;
    }
    const platform = {}
    for (const key in platforms) {
        if(platforms[key]){
            platform[key] = true
        }
    }
    axios.post('/analytics/collect-data', {id, model, type, platform, additional_data})
}
